module.exports = __webpack_public_path__ + "img/icon_arrow_down.25e68cb4.svg";